<span class="font-medium-title-large">Datei veröffentlichen</span>

<form [formGroup]="form" class="flex-c gap-24 w-full" (ngSubmit)="submit()">
  <div class="input-simple">
    <div class="input-label">Datei*</div>
    <input
      #fileInput
      class="hidden-file-input"
      type="file"
      (change)="onFileSelected($event)" />
    <button
      type="button"
      class="inwi-icon-text-button-medium-primary"
      (click)="triggerFileSelect()">
      <div class="button-content">
        <i class="fa-regular fa-paperclip-vertical button-icon"></i>
        <div class="button-text">Datei auswählen</div>
      </div>
    </button>
    @if (!selectedFile) {
      <span class="font-regular-body-small">Bitte Datei auswählen.</span>
    } @else {
      <span class="font-regular-body-small">{{ selectedFile.name }}</span>
    }
    @if (fileError) {
      <span class="error-text">{{ fileError }}</span>
    }
  </div>

  @if (selectedFile) {
    <div class="input-simple">
      <div class="input-label">Dateiname*</div>
      <input
        class="input-field"
        formControlName="fileName"
        type="text"
        placeholder="Dateiname" />
      <span class="font-regular-body-small text-secondary">
        Wenn keine Endung angegeben ist, wird die ursprüngliche Endung verwendet.
      </span>
    </div>
  }

  <div class="input-select">
    <div class="input-label">Mitgliederbereiche*</div>
    <p-multiSelect
      [options]="memberAreas"
      formControlName="areaIds"
      appendTo="body"
      optionLabel="name"
      optionValue="id"
      [showClear]="true"
      [filter]="true"
      placeholder="Bereiche auswählen">
    </p-multiSelect>
  </div>

  <div class="flex-r gap-16 justify-center">
    <button
      type="button"
      class="inwi-text-button-large-secondary flex-1-0-0"
      (click)="closeDialog()">
      <div class="button-content"><div class="button-text">Abbrechen</div></div>
    </button>
    <button
      type="submit"
      class="inwi-text-button-large-primary flex-1-0-0"
      [disabled]="form.invalid || !selectedFile">
      <div class="button-content"><div class="button-text">Veröffentlichen</div></div>
    </button>
  </div>
</form>
